import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from '../reducers/main';
import thunk from 'redux-thunk';

export function configureStore(initialState) {
  return createStore(rootReducer, initialState, applyMiddleware(thunk));
}
